import http from '../_httpHandlers';
import { config } from '../_config';
import { IPatchNotesComponent } from '../_types/interfaces';

const uri = config.backendAddress;

const getLocalPatchNotes = async (serviceName: string): Promise<string> => {
    return await http.post(`${uri}/GetPatchNotes`, serviceName, 'text');
};

const getLocalPatchNotesService = async (serviceName: string): Promise<string> => {
    return await http.post(`${uri}/GetServicePatchNote`, serviceName, 'text');
};

const getLocalPatchNotesPlugin = async (pluginName: string): Promise<string> => {
    return await http.post(`${uri}/GetPlaginPatchNote`, pluginName, 'text');
};

const getGlobalPatchNote = async (uriService: string, serviceName: string): Promise<string> => {
    return await http.post(`${uriService}/GetPatchNote`, serviceName, 'text');
};

export const PatchNotesService: IPatchNotesComponent = {
    getLocalPatchNotes,
    getLocalPatchNotesService,
    getLocalPatchNotesPlugin,
    getGlobalPatchNote,
};